import { Reducer } from 'redux'

import {
  BuyerContractsAction,
  BuyerContractsActionTypes,
  Contracts,
  initialBuyerContractsState,
} from './types'

export const reducer: Reducer<Contracts, BuyerContractsAction> = (
  state = initialBuyerContractsState,
  action
) => {
  switch (action.type) {
    case BuyerContractsActionTypes.SET_BUYER_CONTRACTS: {
      return {
        ...state,
        contracts: action.payload.contracts,
      }
    }
    default:
      return state
  }
}
